import RadioComponent from './radio.component'

const RadioModule = angular.module('cdbl.radio', [

])
  .component('cdblRadio', RadioComponent)
  .name

export default RadioModule
